module.exports = __webpack_public_path__ + "img/Vitis_vinifera.1c6d39c4.jpg";